import Vue from 'vue'
import VueRouter from 'vue-router'
//  eslint-disable-next-line
import Loading from '../views/Loading'
// import Model from '../model'
import store from '../store'
// import axios from 'axios'
// import qs from 'qs'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Loading',
    component: Loading
  },

  {
    path: '/waiting',
    name: 'Waiting',
    component: () => import('../views/Waiting.vue')
  },

  {
    path: '/waitingMatch',
    name: 'WaitingMatch',
    component: () => import('../views/WaitingMatch.vue')
  },

  {
    path: '/playing',
    name: 'Playing',
    component: () => import('../views/Playing.vue')
  },

  {
    path: '/index',
    name: 'Index',
    component: () => import('../views/Index.vue')
  },

  {
    path: '/questions',
    name: 'Questions',
    component: () => import('../views/Questions.vue')
  },

  {
    path: '/review',
    name: 'Review',
    component: () => import('../views/Review.vue')
  },

  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach(async (to, from, next) => {
  if (!window.initUrl) {
    window.initUrl = location.href.split('&')[0]
  }
  if (to.name === 'Loading' || to.name === 'Index' || to.name === 'Questions') {
    next()
  } else if (to.name === 'Waiting') {
    if (store.getters.room_id) {
      next()
    } else {
      const url = window.location.href.split('#')[1]
      let params = {}
      if (url.indexOf('room_id') == -1) {
        next({ path: '/index' })
      } else {
        const params_str = url.split('?')[1]
        const params_arr = params_str.split('&')
        params_arr.forEach(item => {
          params[item.split('=')[0]] = item.split('=')[1]
        })
        next({ path: '/index', query: { room_id: params.room_id } })
      }
    }
  } else {
    if (store.getters.room_id) {
      next()
    } else {
      next({ path: '/index' })
    }
  }
})

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}

export default router
